import React from 'react';
import HeaderTwo from '../common/header/HeaderTwo';
import HeaderOne from "../common/header/HeaderOne";
import Breadcrumb from '../common/breadcrumb/Breadcrumb';
import Termcomponent from '../components/term/Termcomponent';
import ContactMap from '../components/contact/ContactMap';
import BrandOne from '../components/brand/BrandOne';
import FooterOne from '../common/footer/FooterOne';

const Contact = () => {
    return (
        <>
            <HeaderOne />
   
            <Termcomponent />
           
            <FooterOne />
        </>
    )
}

export default Contact;